<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5" id="grad1">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },

                  {
                    title: 'Event Wizard',
                    active: true
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Event Wizard</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-3 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li class="active" id="NewTraining">
                                                <strong>Event Assignment</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" class="" title="Click on View Wizard in below table" id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" class="" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" class="" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" class="" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" class="" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" class="" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li @click="$bvModal.show('bv-modal-example')" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                        </ul>
                                        <fieldset style="text-align: left;padding: 30px;" v-if="isForm">
                                            <h5>Add New Event</h5>
                                            <form @submit.prevent="TrainingCreationForm">
                                                <div class="row mt-5">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6 ">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Event Title
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                            <input class="floating-input form-control" v-model="trainingtitle" type="text" placeholder="Event Title" id="training_title" />
                                                        </div>
                                                    </div>
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Select Sub Program</label>
                                                            <selectize id="select-state sub_program" class="text-capitalize " v-model="subprogram" :settings="subProgramSetting" :searchable="true">
                                                                <option v-for="(item, index) in subprogramsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                                                    {{ item.title }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Select Project</label>
                                                            <selectize id="select-state project" class="text-capitalize" v-model="project" :settings="projectSetting" :searchable="true">
                                                                <option v-for="(item, index) in projectsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                                                    {{ item.title }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Assign to Advisor</label>
                                                            <selectize id="select-state advisor" class="text-capitalize" v-model="advisor" :settings="advisorSetting" :searchable="true">
                                                                <option v-for="(item, index) in advisorArray" :key="index" :value="item.id" :text="item.name" class="text-capitalize">
                                                                    {{ item.name }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Thematic Area
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                            <selectize id="select-state thematic_area" v-model="thematicareaSelectedUpdate" :settings="thematicareasettings">
                                                                <option v-for="(item, index) in valuesArray" :key="index" :value="item.id">
                                                                    {{ item.name }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                   <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label style="font-weight:700;">Type
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                        <selectize v-model="typetraining_id"  id="type">
                                                            <!-- settings is optional -->
                                                            <option v-for="(tType,index) in trainingTypeArr" :key="index" :value="tType.id">
                                                                {{tType.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                </div>
                                                    
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                    <label style="font-weight:700;" for="first">Location
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state location" v-model="district_id" >
                                                        <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                                            {{item.title}}, {{item.province.title}},
                                                            {{item.province.country.title}}
                                                        </option>
                                                    </selectize>
                                                </div>
                                                </div>
                                                <div class="row">
                                                    <div class="bd-highlight ml-3">
                                                        <div class="form-check">
                                                            <vs-checkbox v-model="showReference" id="show_ref">
                                                                <b>Enable References</b>
                                                            </vs-checkbox>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="submit" class="btn btn-primary btn-sm">
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>
                                        <fieldset style="text-align: left;padding: 30px;" v-if="isEditForm == true">
                                            <h5>Add New Training</h5>
                                            <form @submit.prevent="submitEditForm">
                                                <div class="row mt-5">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Event Title
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                            <input class="floating-input form-control" v-model="trainingtitle" type="text" placeholder="Event Title" id="training_title" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Select Sub Program</label>
                                                            <selectize id="select-state sub_program" class="text-capitalize" v-model="subprogram" :settings="subProgramSetting" :searchable="true">
                                                                <option v-for="(item, index) in subprogramsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                                                    {{ item.title }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Select Project</label>
                                                            <selectize id="select-state project" class="text-capitalize" v-model="project" :settings="projectSetting" :searchable="true">
                                                                <option v-for="(item, index) in projectsArray" :key="index" :value="item.id" :text="item.title" class="text-capitalize">
                                                                    {{ item.title }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Assign to Advisor</label>
                                                            <selectize id="select-state" class="text-capitalize" v-model="advisor" :settings="advisorSetting" :searchable="true">
                                                                <option v-for="(item, index) in advisorArray" :key="index" :value="item.id" :text="item.name" class="text-capitalize">
                                                                    {{ item.name }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label style="font-weight:700;" for="first">Thematic Area
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                            <selectize id="select-state thematic_area" v-model="thematicareaSelectedUpdate" :settings="thematicareasettings">
                                                                <option v-for="(item, index) in valuesArray" :key="index" :value="item.id">
                                                                    {{ item.name }}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label style="font-weight:700;">Type
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                                        <selectize v-model="typetraining_id"  id="type">
                                                            <!-- settings is optional -->
                                                            <option v-for="(tType,index) in trainingTypeArr" :key="index" :value="tType.id">
                                                                {{tType.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                    <label style="font-weight:700;" for="first">Location
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state location" v-model="district_id" >
                                                        <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                                            {{item.title}}, {{item.province.title}},
                                                            {{item.province.country.title}}
                                                        </option>
                                                    </selectize>
                                                </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="bd-highlight ml-3">
                                                        <div class="form-check">
                                                            <vs-checkbox v-model="showReference" id="enable_ref">
                                                                <b>Enable Reference</b>
                                                            </vs-checkbox>
                                                        </div>
                                                    </div>
                                                </div>

                                                <input type="hidden" v-model="trainingId" />
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <b-button pill type="submit" class="save-btn" variant="primary" id="update">Update</b-button>
                                                            <b-button pill v-if="!isForm" @click="closeEditForm" variant="outline-info" id="cancel">Cancel</b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-card>
                                        <div class="row">
                                            <div class="col-6 text-left">
                                                <h2 style="color:#06a6e0">
                                                    List of All-Time Events
                                                </h2>
                                            </div>
                                            <div class="col-6">
                                                <input type="text" placeholder="Search ..." v-model="searchQuery" class="search_button form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="table-responsive">
                                                        <table class="table table-hover text-left">
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Title</th>
                                                                <th>Code</th>
                                                                <th>Project Title</th>
                                                                <th>Sub Program</th>
                                                                <th>Added at</th>
                                                                <th>Action</th>
                                                            </tr>
                                                            <tr v-for="(item, index) in filterData" v-bind:key="item.id">
                                                                <td>{{ index + 1 }}</td>
                                                                <td class="text-capitalize">
                                                                    {{ item.title || '' }}
                                                                </td>
                                                                <td v-if="item.training_code != ''">
                                                                    {{ item.training_code || '' }}
                                                                </td>
                                                                <td v-else>
                                                                    <code>Null</code>
                                                                </td>
                                                                <td class="text-capitalize">
                                                                    {{ item.project.title || '' }}
                                                                </td>
                                                                <td class="text-capitalize">
                                                                    {{ item.subprogram.title || '' }}
                                                                </td>
                                                                <td>{{ formatDate2(item.createdAt) }}</td>
                                                                <td>
                                                                    <a @click="editRecord(item.id)">
                                                                        <vs-icon class="mr-0" icon="edit" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                    </a>
                                                                    <a @click="deleteRecord(item.id)">
                                                                        <vs-icon class="mr-0" icon="delete" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>

                                    <!-- new form popup ends -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="bv-modal-example" hide-footer hide-header>
        <form @submit.prevent="viewWizard">
            <div style="padding: 40px">
                <h5 class="text-center">
                    Select training from the dropdown list and view wizard.
                </h5>
                <div class="d-block mt-1">
                    <div class="col-sm-12 form-group">
                        <label>
                            Select Training
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                        </label>
                        <selectize id="select-state training" class="text-capitalize" v-model="viewTrainingCode" :searchable="true">
                            <option v-for="(item, index) in items" :key="index" :value="item.training_code" class="text-capitalize">
                                {{ item.title }}
                            </option>
                        </selectize>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <b-button type="submit" class="mt-2 mr-1 modal-btn" variant="primary">View Wizard</b-button>
                    <b-button variant="outline-primary" class="mt-2 ml-1 modal-btn" @click="$bvModal.hide('bv-modal-example')">Cancel</b-button>
                </div>
            </div>
        </form>
    </b-modal>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Selectize from "vue2-selectize";
import {
    formatDate2
} from "@/utils/DateFormate";


export default {
    data: () => ({
        showReference: true,
        isSidebar: false,
        isForm: true,
        isFormData: false,
        isEditForm: false,
        trainingId: "",
        subprogramsArray: [],
        subProgramSetting: {
            maxItems: 1,
            searchField: ["text"],
            placeholder: "Select sub program here"
        },
        projectsArray: [],
        projectSetting: {
            maxItems: 1,
            searchField: ["text"],
            placeholder: "Select project here"
        },
        advisorArray: [],
        advisorSetting: {
            maxItems: 1,
            searchField: ["text"],
            placeholder: "Select advisor here"
        },
        allTrainigs: [],
        items: [],
        project: "",
        advisor: "",
        subprogram: "",
        trainingtitle: "",
        viewTrainingCode: "",
        searchQuery: "",
        thematicareaSelectedUpdate: [],
        thematicareasettings: {
            maxItems: 10,
            plugins: ["remove_button"],
            // delimiter: "|"
        },
        valuesArray: [],
        typetraining_id: "",
        district_id: "",
        trainingTypeArr: [],
        cityArr: [],
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.allTrainig();
        // Set the initial number of items
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/subprograms/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.subprogramsArray = response.data;
            });
        this.openLoading();

        axios
            .get(process.env.VUE_APP_BASE_PATH + "/advisor/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.advisorArray = response.data;
            });

        axios
            .get(process.env.VUE_APP_BASE_PATH + "/thematics/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.valuesArray = response.data;
            });

            axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingTypeArr = response.data;
            });
            axios
            .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.cityArr = response.data;
            });
    },
    methods: {
        formatDate2,
        // this will show single training wizard
        viewWizard() {
            if (this.viewTrainingCode != "") {
                this.$router.push({
                    path: "/dashboard/admin/training_wizard",
                    query: {
                        trainingId: this.viewTrainingCode
                    }
                });
            } else {
                return false;
            }
        },
        allTrainig: function allTrainig() {
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/admin/training/all/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data;
                });
        },

        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/training/" + id + "/edit")
                .then(response => {
                    this.closeLoading();
                    if (response) {
                        this.subprogram = response.data.subprogram_id;
                        this.project = response.data.project_id;
                        this.trainingtitle = response.data.title;
                        this.advisor = response.data.advisor_id;
                        this.trainingId = response.data.id;
                        this.showReference = !response.data.disableReference;
                        this.thematicareaSelectedUpdate = [];
                        this.typetraining_id = response.data.typetraining_id;
                        this.district_id = response.data.district_id;
                        if (Array.isArray(response.data.thematic_id)) {
                            // If it's already an array, process it directly
                            response.data.thematic_id.forEach(dnr => {
                                this.thematicareaSelectedUpdate.push(dnr.id);
                            });
                        } else if (typeof response.data.thematic_id === 'string') {
                            // If it's a string, split it into an array and process
                            const thematicArray = response.data.thematic_id.split(','); // Split by comma
                            thematicArray.forEach(id => {
                                this.thematicareaSelectedUpdate.push(parseInt(id.trim())); // Convert to integer and push
                            });
                        } 

                    }

                });
        },
        deleteRecord(id) {
            // alert("ID '" +id+ "' is being deleted.");
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/training/delete", {
                                id: id
                            })
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.allTrainig();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        TrainingCreationForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (
                this.thematicareaSelectedUpdate == "" ||
                this.thematicareaSelectedUpdate.length == 0
            ) {
                this.inValid.push("Please select Thematic Area.");
            }
            if (!this.subprogram) {
                this.inValid.push("Please select Sub Program.");
            }
            if (!this.project) {
                this.inValid.push("Please select Project.");
            }
            if (!this.trainingtitle) {
                this.inValid.push("Please enter Event Title.");
            }
            if (!this.advisor) {
                this.inValid.push("Please select advisor.");
            }
            if (!this.district_id) {
                this.inValid.push("Please select Location.");
            }
            if (!this.typetraining_id) {
                this.inValid.push("Please select Training Type.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
            let self = this;
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/admin/create/training", {
                        program_id: this.subprogram,
                        project_id: this.project,
                        trainingtitle: this.trainingtitle,
                        advisor_id: this.advisor,
                        disableReference: !this.showReference,
                        thematic: this.thematicareaSelectedUpdate,
                        typetraining_id: this.typetraining_id,
                        district_id: this.district_id,

                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been saved successfully!");
                            self.resetForm();
                            self.allTrainig();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        // This will update record
        // This will submit form
        submitEditForm(e) {
            e.preventDefault();
            if (this.subprogram == "" && this.trainingtitle == "") {
                this.error = "All fields are required. Fill out all fields, please!";
            } else {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/training/update", {
                        program_id: this.subprogram,
                        project_id: this.project,
                        trainingtitle: this.trainingtitle,
                        advisor_id: this.advisor,
                        id: this.trainingId,
                        thematic: this.thematicareaSelectedUpdate,
                        disableReference: !this.showReference,
                        typetraining_id: this.typetraining_id,
                        district_id: this.district_id,
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainig();
                            self.closeEditForm();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.subprogram = "",
                this.project = "",
                this.trainingtitle = "",
                this.advisor = "",
                this.showReference = true;
                this.thematicareaSelectedUpdate = "";
                this.typetraining_id = "";
                this.district_id = "";
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        printReport: function () {
            window.print();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        showSubProjects(subId) {
            this.openLoading();
            this.projectsArray = [];
            axios.get(process.env.VUE_APP_BASE_PATH + "/subprogram/projects/" + subId + "/filter")
                .then(response => {
                    this.closeLoading();
                    this.projectsArray = response.data;
                });
        },
    },
    watch: {
        subprogram(val) {
            if (val != '') {
                this.showSubProjects(val);
            }
        },
        showReference(newValue) {
            this.showReference = newValue
            // Additional logic can be placed here if needed when value changes
        }
    },

    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Selectize
    },
    computed: {
        filterData: function () {
            const items = JSON.parse(JSON.stringify(this.items));
            return items?.filter((items) => {

                if (
                    String(items.title)
                    .toLowerCase()
                    .indexOf(this.searchQuery.toLowerCase()) !== -1
                ) {
                    return true;
                }

                return false;
            });
        },
    },
};
</script>

<style scoped>
#grad1 {
    background-color: #fff;
}

.modal-dialog {
    background: transparent !important;
}

.modal-dialog input {
    border-radius: 5px !important;
    height: 32px !important;
}

#bv-modal-example___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #e8e8e8;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

/* #msform input,
#msform textarea {
    padding: 0px 8px 4px 8px;
    border: none;
    border-bottom: 1px solid #ccc;
    border-radius: 0px;
    margin-bottom: 25px;
    margin-top: 2px;
    width: 100%;
    box-sizing: border-box;
    font-family: montserrat;
    color: #2c3e50;
    font-size: 16px;
    letter-spacing: 1px;
}

#msform input:focus,
#msform textarea:focus {
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none;
    font-weight: bold;
    border-bottom: 2px solid skyblue;
    outline-width: 0;
} */

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 10%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar .completed {
    color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}

#progressbar .active {
    color: #000000;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.mt-4-training-title {
    margin-top: 27px;
}
</style>
